import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {removeHoldShip} from "../../../services/api/apiNextBarcode"
import Button from "reactstrap/es/Button"
import Promise from 'bluebird'

class BulkRemoveHoldShipModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            // status: '',
            // customerChange: '',
            // note: '',
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: '',
            // validated: false
        }
    }

    componentDidMount = async () => {
        await this._genListItems()
    }

    _genAllItems = () => {
        const {listItems} = this.state

        this._bukdHoldShip(listItems)
    }

    _handleChangeStatus = (e) => {
        const {value} = e.target

        this.setState({
            status: value
        })
    }

    _handleChange = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _genListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _bukdHoldShip = async (listItems) => {
        // const {status} = this.state

        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        // status !== '' && (
            await Promise.each(listItems, async item => {
                this.setState({
                    itemLoading: item._id
                })

                try {
                    // const {note} = {...item}
                    // const newNote = note? note + '\nShip tiếp' : 'Ship tiếp';
                    const {success, message} = await removeHoldShip(item._id)
                    let {itemError, itemsSuccess} = this.state

                    if(success) {

                        itemsSuccess.push(item._id)

                        this.setState({
                            itemsSuccess: itemsSuccess,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        })
                    } else {
                        itemError.push({
                            _id: item._id,
                            message: message
                        })

                        this.setState({
                            itemError: itemError,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        })
                    }
                } catch (e) {
                    let {itemError, itemsSuccess} = this.state

                    this.setState({
                        itemError: e.message,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }

            })
        // )
    }

    _changeItemHoldShip = async (item) => {
        // const {status} = this.state

        try {
            // const {note} = {...item}
            // const newNote = note? note + '\nShip tiếp' : 'Ship tiếp';
            const {success, message} = await removeHoldShip(item._id)
            const {itemsSuccess, itemError} = this.state
            

            if(success) {
                itemsSuccess.push(item._id)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                })
            } else {
                const newItemErr = itemError.map(item2 => {
                    if(item2._id === item._id) {
                        return {
                            ...item2,
                            message: message
                        }
                    }
                    return item2
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        // const {status} = this.state

        // this.setState({
        //     validated: true
        // })

        // if (this.state.customerChange === '' || this.state.note === '') return false

        const r = window.confirm(`Bạn có chắc chắn muốn bỏ đánh dấu tạm dừng vận chuyển cho đơn hàng?`)

        if (r !== true) {
            // this.setState({
            //     status: '',
            //     customerChange: '',
            //     note: '',
            //     validated: false
            // })
            return
        }

        this._genAllItems()
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(item2 => {
            if(item2._id === item._id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: item._id
        })

        this._changeItemHoldShip(item)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._bukdHoldShip(itemError)
    }

    _showMessage = (itemError, itemsSuccess, _id) => {
        if(itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if(itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if(itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Remove hold ship success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    _genIcon = (item) => {
        const {itemsSuccess, itemError} = this.state

        if(itemsSuccess.includes(item._id)) return <i className="icon-check text-success"/>

        if(itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) return <i className="icon-cross text-danger"/>

        return <i className="icon-spinner6 text-dark"/>
    }

    render() {
        const {isOpen, handleToggleModal} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError} = this.state

        return (
            <div>
                <Modal isOpen={isOpen} className="BulkChangeStatus"
                >
                    <ModalHeader>
                        Bỏ đánh dấu tạm dừng vận chuyển cho đơn hàng (Remove Hold Ship)
                    </ModalHeader>
                    <ModalBody>
                        {listItems.length > 0 && (
                            <div className="ListChangeStatus">
                                <span className='list-title d-block mb-2'>Có {listItems.length} đơn hàng cần bỏ hold ship:</span>
                                {
                                    listItems.map(item => {
                                        return (
                                            <div key={item._id} className="ItemChangeStatus d-sm-flex mb-2 pb-2">
                                                <div className="IconStatus mr-2">
                                                    {this._genIcon(item)}
                                                </div>
                                                <div className="ContentChangeStatus">
                                                    <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                    {
                                                        (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                            <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                        )
                                                    }
                                                    {itemLoading === item._id && <i className='icon-spinner2 spinner ml-2'/>}
                                                    {this._showMessage(itemError, itemsSuccess, item._id)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            {itemError.length > 0 && (
                                <Button onClick={this._retryAll} className="bg-danger"><i className="icon-spinner11 mr-1"/>Save again</Button>
                            )}
                            <Button disabled={itemLoading !== ''} onClick={handleToggleModal} className="bg-grey ml-2">
                                Cancel
                            </Button>
                            <Button disabled={itemLoading !== ''} onClick={this._handleSubmit} className="bg-primary ml-2">
                                Save
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default BulkRemoveHoldShipModal